import React, { useEffect, useState } from 'react';
import { AtIcon } from '../AtIcon';
import { Dashboard } from '../../context/DashboardsProvider/types';
import { Link } from 'react-router-dom';

interface SidebarProps {
	onItemClick?: (item: Dashboard) => void;
	dashboards?: Dashboard[];
	dashboardId?: string;
}

export const MlSidebar: React.FC<SidebarProps> = ({
	onItemClick,
	dashboards,
	dashboardId,
}) => {
	const [isOpen, setIsOpen] = useState(true);
	const [search, setSearch] = useState('');

	const handleToggle = () => {
		setIsOpen((prev) => !prev);
	};

	const handleItemClick = (item: Dashboard) => {
		onItemClick?.(item);
		getActiveItem(item, dashboardId ?? '1');
	};

	const filteredItems = dashboards?.filter((item) =>
		item?.report?.name?.toLowerCase().includes(search?.toLowerCase())
	);

	const getActiveItem = (dashboard: Dashboard, dashboardId: string) => {
		return dashboardId === undefined
			? true
			: dashboardId === dashboard?.report?.id.toString();
	};

	return (
		<div
			className={`flex flex-col h-screen bg-primary text-slate-100 border-r border-slate-800 transition-all duration-300 ease-in-out ${
				isOpen ? 'w-72' : 'w-20'
			}`}
		>
			{/* TOP: Logo / Title */}
			<div className='flex items-center gap-3 px-4 pb-4 pt-5'>
				<div className='flex items-center justify-center w-9 h-9 rounded-xl '>
					<img src='/datavision-logo.svg' alt='DataVision Logo' />
				</div>

				{isOpen && (
					<div className='leading-tight'>
						<div className='font-semibold text-base tracking-tight'>
							DataVision
						</div>
						<div className='text-xs text-slate-400'>INSIGHTS</div>
					</div>
				)}
			</div>

			{/* SEARCH */}
			<div className={`px-4 pb-4 ${isOpen ? 'block' : 'hidden'}`}>
				<div className='relative'>
					<div className='absolute inset-y-0 left-3 flex items-center pointer-events-none'>
						<svg
							stroke='currentColor'
							fill='currentColor'
							stroke-width='0'
							viewBox='0 0 512 512'
							height='18px'
							width='18px'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path d='M456.69 421.39 362.6 327.3a173.81 173.81 0 0 0 34.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 0 0 327.3 362.6l94.09 94.09a25 25 0 0 0 35.3-35.3zM97.92 222.72a124.8 124.8 0 1 1 124.8 124.8 124.95 124.95 0 0 1-124.8-124.8z'></path>
						</svg>
					</div>
					{isOpen ? (
						<input
							type='text'
							placeholder='Search dashboards...'
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							className='w-full pl-9 pr-3 py-2 rounded-xl bg-slate-900 border border-slate-700 text-xs placeholder:text-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/60 focus:border-emerald-500/60'
						/>
					) : (
						<div className='w-full h-9 rounded-xl bg-slate-900 border border-slate-800'>
							hola
						</div>
					)}
				</div>
			</div>

			{/* NAV ITEMS */}

			<nav
				className={`flex-1 overflow-y-auto custom-scrollbar px-2 space-y-1 ${
					isOpen ? 'block' : 'hidden'
				}`}
			>
				{filteredItems &&
					filteredItems.map((item, index) => {
						const active = getActiveItem(item, dashboardId ?? '1');
						return (
							<Link
								key={item.report.id}
								to={`/dashboard/${item.report.id.toString()}`}
							>
								<button
									onClick={() => handleItemClick(item)}
									className={`group flex items-center w-full rounded-xl px-3 py-2 text-xs font-medium transition-colors
								${
									active
										? 'bg-slate-800/80 text-slate-50 border border-emerald-500/60 shadow-sm'
										: 'text-slate-300 hover:bg-slate-800/70 hover:text-white'
								}`}
								>
									{isOpen && (
										<span className='text-left leading-snug'>
											{index + 1}. {item.report.name}
										</span>
									)}
								</button>
							</Link>
						);
					})}
			</nav>

			{/* BOTTOM: Collapse button */}
			<div className='px-4 py-4'>
				<button
					type='button'
					onClick={handleToggle}
					className='flex items-center justify-center gap-2 w-full rounded-full bg-slate-900 border border-slate-700 text-xs text-slate-300 py-2 hover:bg-slate-800 hover:border-slate-500 transition-colors'
				>
					{isOpen ? (
						<>
							<span className='flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 rotate-180  '>
								<AtIcon
									type='arrow-right'
									fill={isOpen ? '#000' : 'white'}
									height={30}
									width={30}
								/>
							</span>
							<span>Collapse Sidebar</span>
						</>
					) : (
						<div className={isOpen ? 'rotate-180' : ''}>
							<AtIcon
								type='arrow-right'
								fill={isOpen ? '#000' : 'white'}
								height={30}
								width={30}
							/>
						</div>
					)}
				</button>
			</div>
		</div>
	);
};
